import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useEffect, useState } from "react";
import PageShell from "../../components/PageShell";
import PatientInQueue from "../PatientInQueue";
import IpdReport from "./IpdReports";
import OpdReport from "./OpdReports";
import { useLocation, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.jsx";
import {
  PAGE_TABS_BAR_SX,
  PAGE_TAB_LIST_PROPS,
  TAB_PANEL_SX,
} from "../../utils/pageLayoutStyles";

const inferTabFromPath = (pathname = "") => {
  const path = String(pathname).toLowerCase();
  if (path.includes("/opd-report") || path.includes("/opd-dashboard")) return "opd";
  if (path.includes("/ipd-dashboard")) return "ipd";
  return null;
};

const mapIncomingTab = (t, isDoc, pathname = "") => {
  if (t === "1") return "ipd";
  if (t === "2") return "opd";
  if (t === "queue" || t === "ipd" || t === "opd") return t;
  const fromPath = inferTabFromPath(pathname);
  if (fromPath) return fromPath;
  return isDoc ? "queue" : "ipd";
};

const ManageReport = () => {
  const { patientId } = useParams(); 
  const location = useLocation();
  const { tab: incomingTab } = location?.state || {};
  const { user } = useAuth();
  const isDoctor = user?.roleName === "doctor" || user?.roleName === "surgeon";
  const [selectedTab, setSelectedTab] = useState(() =>
    mapIncomingTab(incomingTab, isDoctor, location.pathname)
  );

  useEffect(() => {
    const nextTab = mapIncomingTab(
      location?.state?.tab,
      isDoctor,
      location.pathname
    );
    setSelectedTab(nextTab);
  }, [location.pathname, location.state, isDoctor]);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <PageShell title="PATIENTS">
      <TabContext value={selectedTab}>
        <Box sx={PAGE_TABS_BAR_SX}>
          <TabList
            {...PAGE_TAB_LIST_PROPS}
            onChange={handleChange}
          >
            {isDoctor && <Tab label="Patients In Queue" value="queue" />}
            <Tab label="In Patients" value="ipd" />
            <Tab label="Out Patients" value="opd" />
          </TabList>
        </Box>
      {isDoctor && (
        <TabPanel value="queue" sx={TAB_PANEL_SX}>
          <PatientInQueue doctorId={patientId} />
        </TabPanel>
      )}
      <TabPanel value="ipd" sx={TAB_PANEL_SX}>
        <IpdReport patientId = {patientId}/>
      </TabPanel>
      <TabPanel value="opd" sx={TAB_PANEL_SX}>
        <OpdReport patientId = {patientId}/>
      </TabPanel>
      </TabContext>
    </PageShell>
  );
};

export default ManageReport;
